import Exit from "@svg/ui/exit.svg"
import UploadIcon from "@svg/ui/upload.svg"
import React from "react"

export const FileUploadButtonAlt = ({ label, files = [], removeFile, handleFileChange, maxFiles = 2 }) => {
  return (
    <div>
      {files.length < maxFiles && (
        <div className="flex mb-2">
          <label
            htmlFor="fileUpload"
            style={{ borderRadius: "28px" }}
            className="flex items-center gap-2 px-3 py-2 font-bold text-white transition-all duration-300 rounded-md cursor-pointer bg-teal-brandAlt hover:bg-opacity-90"
          >
            <div className="fill-current" style={{ width: "16px" }}>
              <UploadIcon />
            </div>
            {label}
          </label>
          <input id="fileUpload" type="file" className="hidden" multiple onChange={handleFileChange} />
        </div>
      )}
      <div className="flex flex-col gap-2">
        {files.map((file, idx) => (
          <div key={file.name + idx} className="flex items-center font-semi">
            <button
              type="button"
              onClick={() => removeFile(idx)}
              className="cursor-pointer fill-current"
              style={{ width: "12px" }}
            >
              <Exit />
            </button>
            <span className="ml-4">{file.name}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
